/**
 * StructureCard Component
 * 
 * A reusable card component for displaying community structure information.
 * Maintains consistent height, width, and styling across all instances.
 * 
 * @param {Object} props
 * @param {string} props.icon - Icon class name (e.g., "icon-coding")
 * @param {string} props.title - Card title text
 * @param {string} props.subtitle - Short description text
 * @param {function} props.onLearnMore - Click handler for Learn More button
 * @param {number} props.index - Index for animation delay
 * @param {React.Ref} props.triggerRef - Ref for focus management
 */

import React from 'react';

const StructureCard = ({
    icon,
    title,
    subtitle,
    onLearnMore,
    index,
    triggerRef
}) => {
    return (
        <div
            className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
            data-wow-delay={`${(index + 1) * 100}ms`}
        >
            <div className="services-two__single">
                <div className="services-two__icon">
                    <span className={icon}></span>
                </div>
                <h3 className="services-two__title">
                    <a href="#!" onClick={(e) => e.preventDefault()}>
                        {title.split(' & ').join(' & \n').split('\n').map((line, i) => (
                            <React.Fragment key={i}>
                                {line}
                                {i < title.split(' & ').length - 1 && <br />}
                            </React.Fragment>
                        ))}
                    </a>
                </h3>
                <p className="services-two__text">{subtitle}</p>
                <div className="services-two__btn-box">
                    <button
                        ref={triggerRef}
                        onClick={onLearnMore}
                        className="thm-btn services-two__btn"
                        style={{
                            border: 'none',
                            padding: 0,
                            font: 'inherit',
                            cursor: 'pointer',
                            textDecoration: 'none'
                        }}
                    >
                        Learn more
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StructureCard;
